import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import AccountSettings from '../modules/auth/components/AccountSettings'
import { MFA } from '../modules/auth/components/MFA'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { allRoutes } from './allRoutesHandler'
import { ScoringMethodIndexRoutes } from './pages/admin/general/scoring-method/ScoringMethodRoutes'
import { NursesNotesIndexRoutes } from './pages/records/NursesNotesRoutes'
import PermittedRoute from './PermittedRoute'
import { BehaviourNotesIndexRoutes } from './pages/behaviour_notes/BehaviourNotesRoutes'
import behaviorsIndexRoute from './pages/admin/general/behaviors/behaviorsIndexRoute'
import DeletedAssessmentNotes from './pages/deleted-notes/deletedNotes'
// Lazy load all direct components
const AuthPageRoutes = lazy(() => import('./modules/auth/AuthPageRoutes'))
const WoundIndexRoute = lazy(
  () => import('./pages/wound_care/WoundIndexRoute')
)
const PhysicalTherapistNotesRoutes = lazy(
  () => import('./pages/notes/PhysicalTherapistNotes/PhysicalTherapistNotes')
)
const OccupationalTherapyNotesRoutes = lazy(
  () => import('./pages/notes/OccupationalTherapyNotes/OccupationalTherapyNotes')
)
const SpeechTherapyNotesRoutes = lazy(
  () => import('./pages/notes/SpeechTherapyNotes/SpeechTherapyNotes')
)
const AttendanceTypeIndexRoutes = lazy(
  () => import('./pages/billing/professionalclaim/attendance-type/AttendanceTypeIndexRoutes')
)
const DescriptionCodeIndexRoutes = lazy(
  () => import('./pages/billing/professionalclaim/description-code/DescriptionCodeIndexRoutes')
)
const FundingSourceIndexRoutes = lazy(
  () => import('./pages/admin/billing/funding-source/FundingSourceIndexRoutes')
)

const PayersSettingIndexRoutes = lazy(
  () => import('./pages/admin/billing/payers-setting/PayersSettingIndex')
)
const ContactIndexRoutes = lazy(() => import('./pages/admin/care/contact/ContactIndexRoutes'))
const EnrollmentIndexRoutes = lazy(
  () => import('./pages/admin/care/enrollment/EnrollmentIndexRoutes')
)
const EnrollmentBPIndexRoutes = lazy(
  () => import('./pages/admin/general/enrollment-by-program/EnrollmentBPindexRoutes')
)
const IndividualIntakeIndexRoutes = lazy(
  () => import('./pages/admin/care/individual-intake/IndividualIntakeIndexRoutes')
)
const InsuranceIndexRoutes = lazy(() => import('./pages/admin/care/insurance/InsuranceIndexRoutes'))
const TLogsIndexRoutes = lazy(() => import('./pages/admin/care/clientlogs/ClientLogsIndex'))
const ProgramIndexRoutes = lazy(() => import('./pages/admin/general/programs/programIndexRoutes'))
const SharedContactIndexRoutes = lazy(
  () => import('./pages/admin/general/shared-contact/SharedContactIndexRoutes')
)
const SiteIndexRoutes = lazy(() => import('./pages/admin/general/site/SiteIndexRoutes'))
const UserIndexRoutes = lazy(() => import('./pages/admin/general/user/UserIndexRoutes'))
const ProviderIndexRoutes = lazy(
  () => import('./pages/admin/service-directory/service-provider/ProviderIndexRoutes')
)
const AttendanceIndexRoutes = lazy(
  () => import('./pages/billing/attendance/attendance/AttendanceIndexRoutes')
)
const ServiceAuthorizationIndexRoutes = lazy(
  () => import('./pages/billing/professionalclaim/service-authorization/ServiceAuthorizationIndex')
)
const MarsIndexRouter = lazy(() => import('./pages/mars/MarsIndexRoutes'))
const BehaviourRoutes = lazy(() => import('./pages/behaviour'))
const BillingProviderIndexRoutes = lazy(
  () => import('./pages/admin/billing/billing-provider/BillingProviderIndexRoutes')
)
const NotesRoutes = lazy(() => import('./pages/notes/NotesRoutes'))
const NotesEntriesRoutes = lazy(() => import('./pages/notes/notesEntries/NotesEntriesRoutes'))
const UsersRoute = lazy(() => import('./pages/users/UsersRoute'))
const RolesRoutes = lazy(() => import('./pages/roles/RolesRoutes'))
const HealthInfoIndexRoute = lazy(
  () => import('./pages/admin/care/healthInfo/HealthInfoIndexRoute')
)
const SchedulesIndexRoute = lazy(() => import('./pages/caregiver/schedules/SchedulesIndexRoute'))
const CaregiverIndexRoute = lazy(() => import('./pages/caregiver/caregiver/CaregiverIndexRoute'))
const TimeSheetIndexRoute = lazy(() => import('./pages/caregiver/timesheet/TimeSheetIndexRoute'))
const Imports = lazy(()=> import('./pages/imports/ImportIndexRoutes'))
const BehavioursIndexRoute = lazy(()=> import('./pages/admin/general/behaviors/behaviorsIndexRoute'))
const Loading = () => <div>Loading...</div>

const AllRoutes: React.FC = () => {
  // const permissionsAuth = (state: any) => state?.roles
  // const permissions = useSelector(permissionsAuth).permissions
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path='/mfa' component={MFA} />
        <Route path='/crafted/account/settings' component={AccountSettings} />

        <Route path='/error/'>
          <ErrorsPage />
        </Route>

        <Route path='/billing/professionalclaim/attendance-type/' component={AttendanceTypeIndexRoutes} />

        <Route path='/billing/professionalclaim/description-code' component={DescriptionCodeIndexRoutes} />
        {/* <Route path='/admin/billing/funding-source' component={FundingSourceIndexRoutes} />
        <Route path='/admin/billing/payers' component={PayersSettingIndexRoutes} /> */}
        <Route path='/admin/care/contact' component={ContactIndexRoutes} />
        <Route path='/admin/care/enrollment' component={EnrollmentIndexRoutes} />
        <Route path='/admin/general/enrollment-by-program' component={EnrollmentBPIndexRoutes} />
        <Route path='/admin/care/individual-intake' component={IndividualIntakeIndexRoutes} />
        <Route path='/admin/care/insurance' component={InsuranceIndexRoutes} />
        <Route path='/admin/care/incident-report' component={TLogsIndexRoutes} />
        <Route path='/admin/care/health' component={HealthInfoIndexRoute} />
        <Route path='/admin/general/programs' component={ProgramIndexRoutes} />
        <Route path='/admin/general/shared-contact' component={SharedContactIndexRoutes} />
        <Route path='/admin/general/scoring-method' component={ScoringMethodIndexRoutes} />
        <Route path='/notes/nurses-notes' component={NursesNotesIndexRoutes} />
        <Route path='/notes/physical-therapist-notes' component={PhysicalTherapistNotesRoutes} />
        <Route path='/notes/behavior-notes' component={BehaviourNotesIndexRoutes} />
        <Route path='/notes/occupational-therapy-notes' component={OccupationalTherapyNotesRoutes} />
        <Route path='/notes/speech-therapy-notes' component={SpeechTherapyNotesRoutes} />
        <Route path='/deleted-notes' component={DeletedAssessmentNotes} />
        <Route path='/admin/general/site' component={SiteIndexRoutes} />
        <Route path='/admin/general/user' component={UserIndexRoutes} />
        <Route path='/admin/general/behavior' component={behaviorsIndexRoute} />
        <Route path='/admin/service-directory/service-provider' component={ProviderIndexRoutes} />
        <Route path='/billing/attendance' component={AttendanceIndexRoutes} />
        <Route
          path='/billing/professionalclaim/service-authorization'
          component={ServiceAuthorizationIndexRoutes}
        />

        <Route path='/mars' component={MarsIndexRouter} />

        <Route path='/behaviour' component={BehaviourRoutes} />
        <Route path='/notes/caregiver-notes/notes' component={NotesRoutes} />
        <Route path='/notes/caregiver-notes/notesEntries/:id' component={NotesEntriesRoutes} />
        {/* <Route path='/admin/billing/billing-provider' component={BillingProviderIndexRoutes} /> */}
        <Route path='/users' component={UsersRoute} />
        <Route path='/roles' component={RolesRoutes} />
        <Route path='/caregivers/schedules' component={SchedulesIndexRoute} />
        <Route path='/caregivers/sheets' component={TimeSheetIndexRoute} />
        <Route path='/care-providers' component={CaregiverIndexRoute} />
        <Route path='/import' component={Imports} />
        <Route path='/wound-care' component={WoundIndexRoute} />
        {allRoutes.map((route) => (
          <PermittedRoute
            key={route.path}
            path={route.path}
            component={route.component}
            componentHeader={route.componentHeader}
            permission={route.permission}
          />
        ))}

        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/auth/' component={AuthPageRoutes} />
        <Redirect exact from='/' to='/dashboard' />
        {/* <Redirect to='error/404' /> */}
        {/* <Logout></Logout> */}
      </Switch>
    </Suspense>
  )
}

export default AllRoutes
